import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import LoginForm from './components/LoginForm';
import SocialAuth from './components/SocialAuth';
import TrustSignals from './components/TrustSignals';
import RegistrationPrompt from './components/RegistrationPrompt';

const LoginPage = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/home');
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-card border-b border-border shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center space-x-2 cursor-pointer" onClick={handleBackToHome}>
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Ticket" size={20} color="white" />
              </div>
              <span className="text-xl font-semibold text-foreground">Tixful</span>
            </div>

            {/* Back to Events */}
            <Button
              variant="ghost"
              size="sm"
              iconName="ArrowLeft"
              onClick={handleBackToHome}
              className="text-muted-foreground hover:text-foreground"
            >
              <span className="hidden sm:inline ml-2">Back to Events</span>
            </Button>
          </div>
        </div>
      </header>
      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-md">
          {/* Welcome Section */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="LogIn" size={32} className="text-primary" />
            </div>
            <h1 className="text-2xl font-bold text-foreground mb-2">
              Welcome Back
            </h1>
            <p className="text-muted-foreground">
              Sign in to your account to access your tickets and manage your events
            </p>
          </div>

          {/* Login Card */}
          <div className="bg-card rounded-lg shadow-lg border border-border p-6 sm:p-8">
            {/* Login Form */}
            <LoginForm />

            {/* Social Authentication */}
            <div className="mt-6">
              <SocialAuth />
            </div>

            {/* Registration Prompt */}
            <RegistrationPrompt />

            {/* Trust Signals */}
            <TrustSignals />
          </div>

          {/* Help Section */}
          <div className="mt-8 text-center">
            <p className="text-xs text-muted-foreground">
              Need help? Contact our{' '}
              <button className="text-primary hover:text-primary/80 font-medium">
                support team
              </button>
            </p>
          </div>
        </div>
      </main>
      {/* Footer */}
      <footer className="bg-card border-t border-border py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
            <div className="flex items-center space-x-6 text-sm text-muted-foreground">
              <button className="hover:text-foreground transition-colors">Privacy Policy</button>
              <button className="hover:text-foreground transition-colors">Terms of Service</button>
              <button className="hover:text-foreground transition-colors">Help Center</button>
            </div>
            <div className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} Tixful. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LoginPage;